import React from "react";
import Services from "../common/services";
import { useSelector } from "react-redux";
import useServices from "../hooks/useServices";
import EditServices from "../common/services/editServices/index";


export default function AgencyServices({ lockService }) {
  const userDetails = useSelector((state) => state.userDetails || {});
  const isVendor = userDetails?.vendorId;

  const { onEditServices, setIsEditServices, isEditServices, isLoading } =
    useServices({});
  const handleEditClick = () => {
    setIsEditServices(true);
  };

  const handleSave = async (values) => {
    onEditServices(values);
  };

  if (isEditServices) {
    return (
      <div className="flex flex-col  gap-[20px] p-[24px] w-full">
        <EditServices
          onDiscard={() => {
            setIsEditServices(false);
          }}
          onSave={(values) => handleSave(values)}
          isLoading={isLoading}
        />
      </div>
    );
  }
  return (
    <Services
      onEditClick={handleEditClick}
      isVendor={isVendor}
      lockService={lockService}
    />
  );
}
